import React, { createRef, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import ProjectsData from '../components/Projects.json'
import ProjectListItem from '../components/ProjectTable'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretUp, faCaretDown } from '@fortawesome/free-solid-svg-icons'
import { ArrowUp, ArrowDown } from '../assets/icons'
import img from '../assets/Banners/Banner - 001_shorter.jpg'

export default function Projects() {
    /* deleted on 10/8/25
    {
        "precinct": 4,
        "number": "4.04",
        "title": "Kelly Road Improvements",
        "funding": "",
        "desc": "This project consists of the reconstruction of Kelly Road from Kimberly Ann Lane to FM 1187. This project includes reconstructing 2.1 miles of the existing rural two-lane asphalt roadway. The project will include safety improvements including new culverts, guardrail, signage, and pavement markings. The project will include intersection improvements at FM 1187.  ",
        "filePath": "../assets/ProjectExhibits/Project Exhibits for Website Page 019.png",
        "id": 23
    },
    {
        "precinct": 1,
        "number": "5.03",
        "title": "SH 199 Intersection at Old Agnes Road",
        "funding": "",
        "desc": "This project aims to enhance the safety and functionality of the intersection by implementing measures to reduce speed on SH 199 and modification of the pavement markings to end the passing lane prior to the intersection of Old Agnes Road.  Additional development north of Old Agnes will be monitored for consideration of turn lanes and/or traffic signals.  ",
        "filePath": "../assets/ProjectExhibits/Project Exhibits for Website Page 023.png",
        "id": 6
    },
     {
        "precinct": 3,
        "number": "5.13",
        "title": "BB Fielder Road Extension",
        "funding": "",
        "desc": "This project focuses on extending BB Fielder Road from Old Dennis Road to Ric Williamson Memorial Highway (RWMH). The project will extend approximately 4,900 feet and will involve constructing a new urban four-lane concrete road. The project will also incorporate drainage improvements and intersection improvements at the Old Dennis Road intersection. This extension will provide an additional east/west connectivity option parallel to IH-20, extending from RWMH to the eastern side of FM 51.",
        "filePath": "../assets/ProjectExhibits/Project Exhibits for Website Page 015.png",
        "id": 17
    },
    deleted on 3/5/26
        {
        "precinct": 2,
        "number": "2.05",
        "title": "Precinct Wide Safety Study",
        "funding": "",
        "desc": "This project involves a comprehensive safety study across the entire precinct. This study will assess past accidents and identify safety issues through engineering evaluations. Additionally, the project will hold public workshops to gather more input from the community regarding transportation safety concerns. After collecting data, a safety report will be created, outlining short-term, midterm, and long-term transportation enhancements aimed at making the transportation network safer.",
        "filePath": "",
        "id": 29,
        "designer": "",
        "contractor": ""
    },
        {
        "precinct": 2,
        "number": "5.01",
        "title": "FM 730 Extension",
        "statusUpdate": "This project has been placed on hold, indefinitely. The County will focus on other parnership projects with NCTCOG and TxDOT.",
        "funding": "",
        "desc": "This project focuses on extending FM 730 from US 180 to the IH-20 westbound frontage road. The extension will extend approximately 4,900 feet and will entail constructing an urban 4-lane divided concrete roadway, including a new bridge structure. The project will include intersection improvements at the US 180. ",
        "filePath": "../assets/ProjectExhibits/Project Exhibits for Website Page 022.png",
        "id": 11,
        "designer": "",
        "contractor": ""
    },
    */
    const [projectLinks, setProjectLinks] = useState([])
    const [sortBy, setSortBy] = useState(['Number', false])
    const [projectMap, setProjectMap] = useState('')
    const [projects, setProjects] = useState('')

    const map = (window.innerWidth > 991) ?
        <iframe title="Precinct Map" style={{ width: "100%", maxHeight: "100%", overflow: "hidden", overflowX: "hidden", overflowY: "hidden" }} height="600" width="1200" src="https://fni.maps.arcgis.com/apps/dashboards/ebe799ca5e734046b56a56d6cc0e2f60"></iframe>
        : <iframe title="Precinct Map" style={{ width: "100%", maxHeight: "100%", overflow: "hidden", overflowX: "hidden", overflowY: "hidden" }} height="600" width="1200" src="https://fni.maps.arcgis.com/apps/dashboards/ebe799ca5e734046b56a56d6cc0e2f60"></iframe>

    const ref = createRef();
    const { state } = useLocation()

    const sortByNumber = (data) => {
        data.sort((a, b) => {
            if (a.number === b.number) {
                a = a.title.toLowerCase()
                b = b.title.toLowerCase()
                return (a < b) ? -1 : (a > b) ? 1 : 0
            }
            a = a.number.toLowerCase()
            b = b.number.toLowerCase()
            return (a < b) ? -1 : (a > b) ? 1 : 0
        })
    }

    const sortByName = (data) => {
        data.sort((a, b) => {
            a = a.title.toLowerCase()
            b = b.title.toLowerCase()
            return (a < b) ? -1 : (a > b) ? 1 : 0
        })
    }

    const sortByNumberReverse = (data) => {
        data.sort((a, b) => {
            if (a.number === b.number) {
                a = a.title.toLowerCase()
                b = b.title.toLowerCase()
                return (a > b) ? -1 : (a < b) ? 1 : 0
            }
            a = a.number.toLowerCase()
            b = b.number.toLowerCase()
            return (a > b) ? -1 : (a < b) ? 1 : 0
        })
    }

    const sortByNameReverse = (data) => {
        data.sort((a, b) => {
            a = a.title.toLowerCase()
            b = b.title.toLowerCase()
            return (a > b) ? -1 : (a < b) ? 1 : 0
        })
    }
    const sortByPrecinct = (data) => {
        console.log(data);
        data.sort((a, b) => {
            a = a.precinct
            b = b.precinct
            return (a < b) ? -1 : (a > b) ? 1 : 0
        })
    }
    const sortByPrecinctReverse = (data) => {
        data.sort((a, b) => {
            a = a.precinct
            b = b.precinct
            return (a > b) ? -1 : (a < b) ? 1 : 0
        })
    }

    useEffect(
        () => {
            if (sortBy[0] === 'Name' && sortBy[1] === false) sortByName(ProjectsData)
            else if (sortBy[0] === 'Number' && sortBy[1] === false) sortByNumber(ProjectsData)
            else if (sortBy[0] === 'Precinct' && sortBy[1] === false) sortByPrecinct(ProjectsData)
            else if (sortBy[0] === 'Name' && sortBy[1] === true) sortByNameReverse(ProjectsData)
            else if (sortBy[0] === 'Number' && sortBy[1] === true) sortByNumberReverse(ProjectsData)
            else if (sortBy[0] === 'Precinct' && sortBy[1] === true) sortByPrecinctReverse(ProjectsData)

            var data = ProjectsData.map((d) => {
                return (<ProjectListItem title={d.title} id={d.id} number={d.number} key={d.id} precinct={d.precinct} precinct2={d.precinct2} />)
            })
            setProjectLinks(data)
        }, [sortBy]

    )

    useEffect(() => {
        if (state == null) return;
        if (state.fromProjects === false) return;
        window.scrollTo({ left: 0, top: ref.current.offsetTop, behavior: 'smooth' })
    }, [state, ref])

    const handleClick = (sort) => {
        if (sortBy[0] === sort) setSortBy([sortBy[0], !sortBy[1]])
        else if (sortBy[0] !== sort && sort === 'Name') setSortBy(['Name', false])
        else if (sortBy[0] !== sort && sort === 'Number') setSortBy(['Number', false])
        else if (sortBy[0] !== sort && sort === 'Precinct') setSortBy(['Precinct', false])
    }


    return (
        <div>
            <main className='flex-shrink-0 modular min-vh-100'>
                <div style={{ position: "relative", width: "100%" }}>
                    <img
                        src={img}
                        className="d-block w-100"
                        style={{ objectFit: "cover" }}
                    />
                    <div style={{
                        position: "absolute",
                        top: "50%",
                        left: "0",
                        right: "0",
                        transform: "translateY(-50%)",
                        textAlign: "center",
                    }}>
                        <div className="container">
                            <h1 style={{ fontWeight: '600', fontSize: 'clamp(0.8rem, 3vw, 2.5rem)' }} id="bannerText">
                                Projects Map
                            </h1>
                        </div>
                    </div>
                </div>
                <div className="container py-4">
                    <div className="row mb-3">
                        <div className='col-12'>
                            <iframe title="Precinct Map" style={{ width: "100%", maxHeight: "100%", overflow: "hidden", overflowX: "hidden", overflowY: "hidden" }} height="600" width="1200" src="https://fni.maps.arcgis.com/apps/dashboards/ebe799ca5e734046b56a56d6cc0e2f60"></iframe>
                        </div>
                    </div>
                    <div className="row">
                        <h1>Projects</h1>
                        <table className='table table-striped table-hover mx-auto' style={{ width: "90%" }}>
                            <thead>
                                <tr>
                                    <th className="col-2 hover">
                                        <div className='table-button text-start' onClick={() => handleClick('Number')}>
                                            <h4>Project {sortBy[0] === 'Number' ? (sortBy[1] === false) ? <ArrowDown /> : <ArrowUp /> : ""}</h4>
                                        </div>
                                    </th>
                                    <th className="col-8 hover">
                                        <div className='table-button text-start' onClick={() => handleClick('Name')}>
                                            <h4>Name {sortBy[0] === 'Name' ? (sortBy[1] === false) ? <ArrowDown /> : <ArrowUp /> : ""}</h4>
                                        </div>
                                    </th>
                                    <th className="col-2 hover">
                                        <div className='table-button text-start' onClick={() => handleClick('Precinct')}>
                                            <h4>Precinct {sortBy[0] === 'Precinct' ? (sortBy[1] === false) ? <ArrowDown /> : <ArrowUp /> : ""}</h4>
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody style={{ cursor: "pointer" }} >
                                {projectLinks}
                            </tbody>
                        </table>
                    </div>
                </div>
            </main>
        </div>
    )
}